@if (compact()) {
  <div
    class="border-standard-outline-light flex h-10 w-full overflow-hidden rounded-xl border-1"
    role="group"
    [attr.aria-label]="ariaLabel()">
    @for (option of options(); track option.value) {
      @let isActiveOption = ngControl.control!.value === option.value;
      <button
        type="button"
        class="border-standard-outline-light flex min-w-0 flex-1 items-center justify-center gap-2 border-r-1 transition-colors last:border-r-0"
        [disabled]="ngControl.control!.disabled"
        [attr.aria-pressed]="isActiveOption"
        [ngClass]="{
          'bg-standard-selected font-semibold': isActiveOption,
          'hover:bg-standard-hover-main':
            !isActiveOption && !ngControl.control!.disabled,
          'cursor-pointer': !ngControl.control!.disabled,
          'bg-standard-disabled cursor-not-allowed':
            ngControl.control!.disabled,
        }"
        (click)="changeActive(option)">
        @if (isActiveOption) {
          @if (option.iconSrc) {
            <img class="size-5" [src]="option.iconSrc" alt="" />
          } @else {
            <span class="material-symbols-rounded h-6" aria-hidden="true"
              >check</span
            >
          }
        }
        <span>{{ option.label }}</span>
      </button>
    }
  </div>
} @else {
  <div
    #buttonGroup
    class="grid w-full"
    role="group"
    [attr.aria-label]="ariaLabel()"
    [style.grid-template-columns]="gridColumns()"
    [style.--group-surface]="theme.tokens()['surface-raised']"
    [class.cursor-not-allowed]="ngControl.control!.disabled">
    @for (item of items(); track item.option.value) {
      @let option = item.option;
      @let isActiveOption = ngControl.control!.value === option.value;
      <button
        type="button"
        [disabled]="ngControl.control!.disabled"
        [ngClass]="[
          isActiveOption 
            ? 'bg-primary-main/80 text-standard-text-primary border-standard-outline-light'
            : 'bg-standard-background border-standard-outline-light',
        ]"
        [class.border-t-1]="item.firstRow"
        [class.border-l-1]="item.firstColumn"
        [class.rounded-tl-lg]="item.topLeft"
        [class.rounded-tr-lg]="item.topRight"
        [class.rounded-bl-lg]="item.bottomLeft"
        [class.rounded-br-lg]="item.bottomRight"
        (click)="changeActive(option)"
        class="p-input disabled:bg-standard-disabled disabled:text-standard-text-disabled disabled:border-standard-outline-light box-border flex min-w-0 cursor-pointer items-center justify-center gap-2 overflow-hidden border-r-1 border-b-1 px-0 whitespace-nowrap disabled:pointer-events-none enabled:hover:bg-standard-hover-main">
        @if (isActiveOption) {
          @if (option.iconSrc) {
            <img class="size-5" [src]="option.iconSrc" alt="" />
          } @else {
            <span class="material-symbols-rounded h-6" aria-hidden="true"
              >check</span
            >
          }
        }
        {{ option.label }}
      </button>
    }
  </div>
}
